"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _redboxReact2 = require('redbox-react');

var _redboxReact3 = _interopRequireDefault(_redboxReact2);

var _react2 = require('react');

var _react3 = _interopRequireDefault(_react2);

var _reactTransformCatchErrors3 = require('react-transform-catch-errors');

var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);

var _class, _temp2;

var _reactBootstrap = require('react-bootstrap');

var _utils = require('helpers/utils');

var _components2 = require('components');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _components = {
    RegistrationConfirmView: {
        displayName: 'RegistrationConfirmView'
    }
};

var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
    filename: '/usr/local/ibonus/src/components/Registration/RegistrationConfirm/default/RegistrationConfirmView.jsx',
    components: _components,
    locals: [],
    imports: [_react3.default, _redboxReact3.default]
});

function _wrapComponent(id) {
    return function (Component) {
        return _reactTransformCatchErrors2(Component, id);
    };
}

var RegistrationConfirmView = _wrapComponent('RegistrationConfirmView')((_temp2 = _class = function (_Component) {
    (0, _inherits3.default)(RegistrationConfirmView, _Component);

    function RegistrationConfirmView() {
        var _ref;

        var _temp, _this, _ret;

        (0, _classCallCheck3.default)(this, RegistrationConfirmView);

        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
        }

        return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = RegistrationConfirmView.__proto__ || (0, _getPrototypeOf2.default)(RegistrationConfirmView)).call.apply(_ref, [this].concat(args))), _this), _this.onSubmit = function (event) {
            event.preventDefault();
            _this.props.onSubmit(event);
        }, _this.showAlert = function (alert) {
            var lang = _this.props.lang;


            if (_this.props.errorsList) {
                if (_this.props.errorCode === null || _this.props.errorCode === undefined) {
                    return _react3.default.createElement(
                        _reactBootstrap.Alert,
                        { bsStyle: 'danger', className: 'inner-right-xs' },
                        lang['store.common.server_is_unavailable']
                    );
                } else {
                    return _react3.default.createElement(
                        _reactBootstrap.Alert,
                        { bsStyle: 'danger', className: 'inner-right-xs' },
                        _this.renderErrorList(_this.props.errorsList)
                    );
                }
            } else if (_this.props.alert || alert) {
                var _ref2 = _this.props.alert || alert,
                    message = _ref2.message,
                    style = _ref2.style;

                return _react3.default.createElement(
                    _reactBootstrap.Alert,
                    { bsStyle: style || 'danger', className: 'inner-right-xs' },
                    message
                );
            }

            return '';
        }, _this.renderVoiceCode = function () {
            var additionalFieldSettings = _this.props.settings.additionalFieldSettings;

            if (additionalFieldSettings.find(function (item) {
                return item.typeAdditionalField.slug == 'phone' && item.required_in_registration;
            })) {

                return _react3.default.createElement(_components2.VoiceCode, {
                    login: _this.props.formData.phone,
                    source: 'registration',
                    showAlert: _this.props.showOuterAlert,
                    whiteList: false
                });
            }
            return null;
        }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
    }

    (0, _createClass3.default)(RegistrationConfirmView, [{
        key: 'renderErrorList',
        value: function renderErrorList(list) {
            var _this2 = this;

            if (Array.isArray(list)) {
                return list.map(function (text, i) {
                    return _react3.default.createElement(
                        'p',
                        { key: i },
                        _this2.props.lang[text]
                    );
                });
            } else if (typeof list === 'string') {
                return this.props.lang[list];
            } else {
                return null;
            }
        }
    }, {
        key: 'render',
        value: function render() {
            var _this3 = this;

            var additionalFieldSettings = this.props.settings.additionalFieldSettings;


            return _react3.default.createElement(
                _components2.Preloader,
                { preload: this.props.preload },
                this.props.outerAlert ? this.showAlert(this.props.outerAlert) : this.showAlert(),
                _react3.default.createElement(
                    'section',
                    { id: 'registration-form' },
                    _react3.default.createElement(
                        'div',
                        { className: 'bordered' },
                        _react3.default.createElement(
                            _reactBootstrap.Form,
                            { onSubmit: this.onSubmit },
                            additionalFieldSettings.map(function (item, i) {
                                var typeAdditionalField = item.typeAdditionalField,
                                    required_in_registration = item.required_in_registration;

                                if (typeAdditionalField.slug == 'phone' && required_in_registration) {
                                    return _react3.default.createElement(
                                        _reactBootstrap.FormGroup,
                                        { controlId: 'sms', key: i },
                                        _react3.default.createElement(
                                            _reactBootstrap.ControlLabel,
                                            null,
                                            _this3.props.lang['store.common.enter_sms_code'],
                                            '*'
                                        ),
                                        _react3.default.createElement(_reactBootstrap.FormControl, {
                                            type: (0, _utils.isMobileDevice)() ? "number" : "text",
                                            pattern: '\\d*',
                                            placeholder: '1234',
                                            value: _this3.props.smsCode,
                                            onChange: function onChange(e) {
                                                if ((0, _utils.validateNumeric)(e.target.value)) {
                                                    _this3.props.changeField('smsCode')(e);
                                                }
                                            }
                                        })
                                    );
                                } else if (typeAdditionalField.slug == 'email' && required_in_registration) {
                                    return _react3.default.createElement(
                                        _reactBootstrap.FormGroup,
                                        { controlId: 'email_code', key: i },
                                        _react3.default.createElement(
                                            _reactBootstrap.ControlLabel,
                                            null,
                                            _this3.props.lang['store.registration_form.enter_code_from_mail'],
                                            '*'
                                        ),
                                        _react3.default.createElement(_reactBootstrap.FormControl, {
                                            type: (0, _utils.isMobileDevice)() ? "number" : "text",
                                            pattern: '\\d*',
                                            placeholder: '1234',
                                            value: _this3.props.emailCode,
                                            onChange: function onChange(e) {
                                                if ((0, _utils.validateNumeric)(e.target.value)) {
                                                    _this3.props.changeField('emailCode')(e);
                                                }
                                            }
                                        })
                                    );
                                }
                                return null;
                            }),
                            _react3.default.createElement(
                                _reactBootstrap.FormGroup,
                                null,
                                _react3.default.createElement(
                                    _reactBootstrap.Button,
                                    {
                                        type: 'submit',
                                        className: 'form-control',
                                        bsStyle: 'primary',
                                        disabled: this.props.disabledSubmit
                                    },
                                    this.props.lang['store.common.confirm']
                                )
                            ),
                            this.renderVoiceCode()
                        )
                    )
                )
            );
        }
    }]);
    return RegistrationConfirmView;
}(_react2.Component), _class.propTypes = {
    smsCode: _react2.PropTypes.string.isRequired,
    changeField: _react2.PropTypes.func.isRequired,
    onSubmit: _react2.PropTypes.func.isRequired,
    disabledSubmit: _react2.PropTypes.bool.isRequired,
    errorsList: _react2.PropTypes.oneOfType([_react2.PropTypes.string, _react2.PropTypes.array]),
    lang: _react2.PropTypes.object
}, _temp2));

exports.default = RegistrationConfirmView;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Registration/RegistrationConfirm/default/RegistrationConfirmView.jsx
// module id = 1747
// module chunks = 0